module.exports = __webpack_public_path__ + "img/login_bg_right.81cb1bee.png";